import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import Pagination from "react-js-pagination";
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import ProductsUpload from '../../Models/ProductsUpload';
import Affiliator from '../../Models/Affiliator';

const minOffset = 0;
const maxOffset = 60;
class AffiliatorRecuitmentBonus extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert('ログインしてください')
            window.location.href = '/login/affiliator';
        };
        const thisYear = (new Date()).getFullYear();
        this.state = {
            _id: false,
            activePage: 1,
            categories: [],
            affiliatorCommission: [],
            seller_name: '',
            category: '',
            affCommission: '',
            affilitedProducts: [],
            user: x,
            thisYear: thisYear,
            selectedYear: thisYear
        };
        this.getRecuitmentBonus();
        // this.getAffiliatorCommission();
    }
    componentDidMount() {
      
        window.scrollTo(0, 0)
        
    }
    getRecuitmentBonus() {
        let x = JSON.parse(localStorage.getItem('info'));
        console.log(x.id)
        Affiliator.getRecuitmentBonus(x.id).then(res => {
            console.log(res.data)
            this.setState({ affilitedProducts:res.data.payload})
        })
    }
    // getCategories() {
    //     ProductsUpload.getCategoryDropdown().then(res => {
    //         this.setState({ categories: res.data.categories })
    //     })
    // }
    // getAffiliatorCommission() {
    //     ProductsUpload.getCategory().then(res => {
    //         this.setState({ affiliatorCommission: res.data.aff_points })
    //     })
    // }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        e.preventDefault()
        document.getElementById('search').disabled = true;
        let data = {
            year: this.state.selectedYear,
            month: this.refs.month.value,
            user: this.state.user.id
        }
        if(this.state.selectedYear != null || this.refs.month.value != null){
            Affiliator.getFilteredBonusRec(data).then(res => {
                if (res.data.status === 200) {
                    this.setState({ affilitedProducts: res.data.rec_bonus });
                    document.getElementById('search').disabled = false;
                }
            })
        } else {
            document.getElementById('search').disabled = false;
        }
    }
    onHandleChange = (evt) => {
    // Handle Change Here
        this.setState({ selectedYear: evt.target.value });
    };
    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    render() {
        const { thisYear, selectedYear } = this.state;
        const options = [];
        
        for (let i = minOffset; i <= maxOffset; i++) {
            const year = thisYear - i;
            options.push(<option value={year}>{year}</option>);
        }
        let x = JSON.parse(localStorage.getItem('info'));
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div>
                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text" style={{width: "100%"}}>
                                        リクルーティングボーナス
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 pt-1">
                                            <div></div>
                                            <select className="catagory_select" ref="month">
                                                <option value=""> 月を選択</option>
                                                <option value="1"> 1月</option>
                                                <option value="2"> 2月</option>
                                                <option value="3"> 3月</option>
                                                <option value="4"> 4月</option>
                                                <option value="5"> 5月</option>
                                                <option value="6"> 6月</option>
                                                <option value="7"> 7月</option>
                                                <option value="8"> 8月</option>
                                                <option value="9"> 9月</option>
                                                <option value="10"> 10月</option>
                                                <option value="11"> 11月</option>
                                                <option value="12"> 12月</option>

                                            </select>
                                        </div>
                                        {/* <div className="col-md-1">
                                            <i className="fa fa-angle-right"></i>
                                        </div> */}

                                        <div className="col-md-3 pt-1">
                                            <div></div>
                                            <select className="catagory_select " ref="affCommission" value={this.selectedYear} onChange={this.onHandleChange}> 
                                                <option value="">年を選択</option>
                                                {options}
                                            </select>
                                        </div>
                                        <div className="col-md-2  ">
                                            <button id="search" name="search" type="submit" className="" 
                                            style={{width:'100%', backgroundColor: "#7ea9e6",borderColor: "#6290d1",height:'35px',borderRadius:'5px',color:'#fff',boxShadow:"#ffffff4d 0px 1px 0px 0px inset" }} 
                                            onClick={this.handleSubmit.bind(this)}> 検索 
                                            </button>
                                        </div>
                                    </div>
                                    <table className="table_individual mt-3">
                                        <tbody>
                                            <tr >

                                                <td style={{ width: '40%' }}>
                                                    金額
                                                </td>
                                                <td colspan="2" style={{ width: '60%' }}>
                                                    （日付）分
                                                </td>
                                                {/* <td style={{ width: '30%' }}>
                                                    月分
                                                </td> */}

                                            </tr>
                                            {this.state.affilitedProducts.map(affi =>
                                                <tr >

                                                    <td style={{ width: '50%' }}>
                                                        {affi.recruitment_bonus}円
                                                    </td>
                                                    <td style={{ width: '30%' }}>
                                                        {affi.year}年
                                                    </td>
                                                    <td style={{ width: '30%' }}>
                                                        {affi.month}月
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {/* <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8 ml-5 mt-4">
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={450}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { AffiliatorRecuitmentBonus }